import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
//import { ButtonComponent } from "../../../components/Controls/Button/Button";
import * as actions from "../../../store/requests/actions";
import { avatar, men1, men2, men3, women1, women2, women3 } from "../../../utils/images";
import TableGridView from "../../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import "../../Patients/style.scss";
import ClippedElement from "../../../components/CLippedElement";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import { requestStatisticsRequest } from "../../../store/dashboard/actions";

const CanceledRequests = ({ intl: { messages } }) => {
  const history = useHistory();
  const { canceledRequests } = useSelector((state) => state.requests);
  const [searchValues, setSearchValues] = useState({});
  const dispatch = useDispatch();
  const { requestStatistics } = useSelector((state) => state.dashboard);
  const mens = [men1, men2, men3];
  const womens = [women1, women2, women3];

  useEffect(() => {
    //rejected requests list
    dispatch(
      actions?.canceledRequestsRequest({
        page: 1,
        requestStatus: 8,
        sort: "created_at,desc",
      })
    );
    dispatch(requestStatisticsRequest())
    return () => {
      dispatch(actions.canceledRequestsReceive([]));
    };
  }, [dispatch]);

  //table n grid view render
  const headings = [
    messages.requests.patient_name,
    messages.requests.request_date,
    messages.requests.request_channel,
    messages.requests.request_status,
    messages.requests.actions,
  ];

  const renderTableData = () => {
    return canceledRequests?.data?.map((request, i) => {
      const { patient_name, created_at, request_source, request_status, request_status_name } =
        request;
      return [
        patient_name ? (
          <ClippedElement tooltipTitle={patient_name} >
            <span>{patient_name}</span>
          </ClippedElement>
        ) : (
          "-"
        ),
        created_at
          ? moment(created_at).format("DD[.]MM[.]YYYY  ,  HH:mm:ss")
          : "-",
        request_source ? request_source : "-",
        request_status_name ? request_status_name : "-",
        <ButtonComponent
          content={request_status === 1 ? messages.buttons.details : messages.patients.form.view_profile}
          type="button"
          classes={`cyan-button px-8`}
          handleClick={() => history.push(`/patient-preview/${request.patient_id}`)}
        />,
      ];
    });
  };
  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.canceledRequestsRequest({
        page,
        requestStatus: 8,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };
  const onImgError = (e, x) => {
    e.target.src = avatar;
  };
  const renderGridView = () => {
    if (canceledRequests?.data?.length > 0) {
      return canceledRequests.data.map((request, ind) => {
        const {
          patient_name,
          created_at,
          request_source,
          request_status,
          patient_image,
          patient_gender_type,
          request_status_name,
        } = request;
        return (
          <div className="col-md-4" key={ind}>
            <div className=" grid-col">
              <div className={`grid-col-img status${request_status || 0}`}>
                {patient_image !== null ? (
                  <img
                    src={patient_image}
                    alt="patient img"
                    onError={(e) => onImgError(e)}
                  />
                ) : (
                  <img src={patient_gender_type 
                    ? patient_gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : patient_gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                    : avatar} alt="avatar img" />
                )}
                <span className="status-label">{request_status_name}</span>
              </div>
              <p className="patient_name">{patient_name}</p>
              <div className="d-flex justify-content-center">
                <p className="mx-3">{request_source}</p>
                <p className="">
                {messages.requests.date}: {moment(created_at).format("DD[.]MM[.]YYYY")}
              </p>
                {/* <p className="mx-3">{request_status}</p> */}
              </div>

              <ButtonComponent
                content={request_status === 1 ? messages.buttons.details : messages.patients.form.view_profile}
                type="button"
                classes={`cyan-button px-8`}
                handleClick={() => history.push(`/patient-preview/${request.patient_id}`)}
              />
            </div>
          </div>
        );
      });
    } else {
      return <div className="grid_no_data">{messages.noData.no_data}</div>
    }
  };
  
  return (
    <>
      {canceledRequests ? (
        <TableGridView
          title={
            <>
              <FormattedMessage
                values={{
                  total: canceledRequests?.total,
                  totals: requestStatistics?.canceled,
                }}
                id="requests.request_of"
                defaultMessage={messages.requests.request_of}
              />
            </>
          }
          Form={<Filterform setSearchValues={setSearchValues} />}
          table={{
            stickyHeader: true,
            headings: headings,
            data: renderTableData(),
            headClass: "bg-white table-head",
            noData: messages.noData.no_data,
          }}
          gridView={renderGridView}
          defaultView="grid"
          pagination={{
            count: canceledRequests.last_page,
            page: canceledRequests.current_page,
            handleChange: handlePageChange,
          }}
        />
      ) : null}
    </>
  );
};

export default injectIntl(CanceledRequests);
